import { useSelector } from "react-redux";
import Txt from "../../../../components/typography/Txt";
import { REDUX_PIPELINE_KEYS } from "../../../../constants/keyNames/reduxPipeline";
import { RouteTableScreen } from "../components/RouteTableScreen";

const OpenTasksRoute = () => {
  const keyName = REDUX_PIPELINE_KEYS.OPEN_TASKS;
  const pipeline = useSelector((state) => state.pipeline?.[keyName]);

  return (
    <RouteTableScreen rowData={pipeline}>
      <Txt>OPEN TASKS - Comin Soon</Txt>
    </RouteTableScreen>
  );
};

export default OpenTasksRoute;
